import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    Renderer2,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import {CommonDataService} from 'app/services/common-data.service';
import {TranslateService} from "@ngx-translate/core";
import {CommonService} from 'app/services/common.service';
import {MainHelper} from "../../models/main-helper";
import * as moment from 'moment';
import * as Popper from 'popper.js/dist/umd/popper';
import {Validators} from "../../../slick-grid/models/validators";
import {BTControl} from "../../../stocks/models/b-t-control";
import {DateTimeEditorOptions} from "../../models/date-time-editor-options";


@Component({
    selector: 'date-time-picker',
    templateUrl: './date-time-picker.component.html',
    styleUrls: ['./date-time-picker.component.css']
})
export class DateTimePickerComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges{
    constructor(public readonly commonData: CommonDataService,
                public translateService: TranslateService,
                public readonly commonService: CommonService,
                private readonly renderer: Renderer2
    ){
        this.dateChange = new EventEmitter<string>();
        this.keyupCust = new EventEmitter<KeyboardEvent>();
        this.vRes = new EventEmitter<boolean>();
        this.helper = new MainHelper();
        this.validators = new Validators(this.translateService);
        this.valControl = BTControl.show;
    }

    @Output() dateChange: EventEmitter<string>;
    @Output() vRes: EventEmitter<boolean>;
    @Output() keyupCust: EventEmitter<KeyboardEvent>;

    @Input() public date: string;
    @Input() hideBtn?: boolean;
    @Input() grid?: boolean;
    @Input() cssClass?: Array<'small-height' | 'small-width' | 'width-auto' | 'grid-small' | 'main-wrp' | 'input-group' | 'very-small-width'>;
    @Input() outerVisibilityControl?: boolean;
    @Input() validationFunction?: (val, item?, editor?, outerData?: any) => Slick.ValidateResults;
    @Input() valControl?: BTControl;
    @Input() outerData?: any;
    @Input() emitOuterValidationError?: boolean;
    @Input() outEditorOptions?: DateTimeEditorOptions;

    @ViewChild('mainWrapper')
    private mainWrapper: ElementRef;

    @ViewChild('picker', {read: ElementRef})
    private pickerRef: ElementRef;

    @ViewChild('inputElement')
    private inputElement: ElementRef;

    public _showPicker: boolean;
    private _innerDate: string | number;
    public _inputDate: string;
    private listenMouseDown: () => void;
    private helper: MainHelper;
    public placeholder: string;
    public startDate: number;
    private popperAddVar: Popper;
    public readonly validators: Validators;
    public _dateValid: Slick.ValidateResults;
    public _validationFunction: (val, item?, editor?, outerData?: any) => Slick.ValidateResults;

    public set innerDate(val: string | number){
        // console.log(val, 'innerDate')
        if (val !== this._innerDate){
            this._innerDate = val;
            this.inputDate = val;
            if (this.grid){
               let res = this._validationFunction(val, null, null, this.getOuterData())
               res.valid && this.emitDateChange();
            }

            this.showPicker = false;
            this.helper.wait( () => this.valControl = this.valControl === BTControl.show ? BTControl.showAgain : BTControl.show, 100)
            // this.showPicker = true;
            // this.showPicker = false;
            // this.helper.wait(() => this.showPicker = false, 100)
        }
    };

    public get innerDate(): string | number{
        return this._innerDate;
    }

    public set dateValid(val: Slick.ValidateResults){
        if (val !== this._dateValid){
            this._dateValid = val;
        }

        this.vRes.emit(val.valid)
        if (this.emitOuterValidationError && !['WrongDate', 'Orders_CheckArrivalDate'].includes(val.msg) && !val.valid || val.valid && this.inputDate){
            this.helper.wait(this.emitDateChange);
            // this.dateChange.emit(moment.utc(this.inputDate, this.helper.getLocale(this.translateService.currentLang)).subtract(new Date().getTimezoneOffset(), 'minutes').format());
        } else if (val && this.outEditorOptions && this.outEditorOptions.emitEmptyDate && this.inputDate === ''){
            this.helper.wait(this.emitDateChange);
        }
    }

    public get dateValid(): Slick.ValidateResults{
        return this._dateValid;
    }

    public set inputDate(val: string | number){
        if (val !== this._inputDate){
            this._inputDate = MainHelper.convertDate(val, this.translateService.currentLang)
        }
    };

    public get inputDate(): string | number{
        return this._inputDate;
    }

    public set showPicker(val: boolean){
        if (val !== this._showPicker){
            this._showPicker = val;
            this.helper.wait(() => val && this.popperAdd(), 1)
        }
    };

    public get showPicker(): boolean{
        return this._showPicker;
    }

    ngOnInit() {
        this.cssClass = this.cssClass ? this.cssClass.concat(['main-wrp', 'input-group']) : ['main-wrp', 'input-group'];
        this.setOnInitDates();
        this.placeholder = this.setPlaceholder();

        !this.valControl ? this.valControl = BTControl.show : null;

        this._validationFunction = (val, item?, editor?, outerData?: any): Slick.ValidateResults => {
            let baseValidation= this.validators.dateValidator(val);
            if (!baseValidation.valid){
                return baseValidation
            } else {
                if (this.validationFunction){
                    return this.validationFunction(val, null, null, outerData);

                } else {
                    return baseValidation
                }

            }
        }
    }

    ngOnChanges(changes: SimpleChanges){
        if (changes['date'] && !changes['date'].firstChange){
            if (changes['date'].currentValue !== changes['date'].previousValue){
                // console.log(changes['date'].currentValue, 'ngOnChanges')
                this.date = changes['date'].currentValue;
                this.setOnInitDates();
            }
        }

        if (changes['outerVisibilityControl'] && !changes['outerVisibilityControl'].firstChange){
             this.showPicker = changes['outerVisibilityControl'].currentValue;
        }
    }

    ngAfterViewInit(){
        this.listenMouseDown = this.renderer.listen('body', 'mousedown', (e: MouseEvent) => this.hideList(e));
        // this.popperAdd();
    }

    ngOnDestroy(){
        this.listenMouseDown && this.listenMouseDown();
        this.popperAddVar && this.popperAddVar.destroy();
    }

    private emitDateChange = (): void => {
        this.dateChange.emit( this.inputDate
            ? moment.utc(this.inputDate, this.helper.getLocale(this.translateService.currentLang)).format()
            : this.inputDate as string
        );
    }

    private setOnInitDates = (): void =>{
        this.startDate = this.date ? moment.utc(this.date).milliseconds() : new Date().getUTCMilliseconds();

        this._innerDate = this.date ? moment.utc(this.date).startOf('day').format() : new Date().getTime();
        // console.log(this.date, this._innerDate, moment.utc(this.date).format(), 'setOnInitDates')

        this.inputDate = this.date
            ? moment.isMoment(this.date)
                ? moment.utc(this.date).format()
                : this.date
            : null;
    }

    //# hide list
    private hideList = (e: MouseEvent): void => {
        if (this.helper.hideList(this.mainWrapper, e, this.renderer)){
            // console.log(this.inputDate, 'hideList')
            this.showPicker = false;
        }
    }

    public onChange = (event: any): void =>{
        // console.log(this.inputDate, 'onChange')
        this.valControl = this.valControl === BTControl.show ? BTControl.showAgain : BTControl.show;
        // this.dateChange.emit(typeof this.inputDate === 'number' ? moment.utc(this.date).startOf('day').format(): this.innerDate as string)
    }

    public readonly getOuterData = (): any =>{
       return this.outEditorOptions && this.outEditorOptions.todayDate ? this.outEditorOptions.todayDate : null
    }

    public readonly onShowPicker = (): void => {
        // console.log(this.innerDate, this.inputDate, this.date, 'onShowPicker')
        this.showPicker = !this.showPicker;
    }

    private readonly setPlaceholder = (): string => {
        switch (this.translateService.currentLang){
            case 'en': return 'DD.MM.YYYY';
            case 'uk': return 'дд.мм.рррр';
            case 'ru': return 'дд.мм.гггг';
            case 'pl': return 'DD.MM.RRRR';
            case 'lt': return 'DD.MM.YYYY';
        }
    }

    //# add popper to this component
    public popperAdd = (): void =>{
        this.popperAddVar = this.helper.popperAdd(this.mainWrapper, this.pickerRef, document.body, 'bottom-start', ['bottom', 'bottom-end'], false);
    };

    public readonly emitKeyUp = (event: KeyboardEvent): void => {
        // console.log(event, 'emitKeyUp');
        // event.stopPropagation();
        this.keyupCust.emit(event)
    }



}



// WEBPACK FOOTER //
// ./src/app/shared/components/date-time-picker.component/date-time-picker.component.ts